/*
 * Lista VIP · Black November — comportamento da página.
 *
 * 1. Barra fixa no topo: aparece quando a pessoa já rolou 30% da primeira seção.
 * 2. Rolagem suave dos links internos marcados com data-vip-scroll ("Como funciona" e o
 *    "Entrar na lista VIP" do fim, que volta para a primeira seção inteira).
 * 3. Feedbacks: sorteia o ritmo em que cada cartão flutua.
 * 4. Contador regressivo até o fim das inscrições (data em data-target, a mesma do formulário).
 *
 * Sem dependências. Vai igual para a Shopify.
 */
(function () {
  'use strict';

  const hero = document.querySelector('.vip-hero');
  const bar = document.querySelector('[data-vip-topbar]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // 1. Barra fixa
  if (hero && bar) {
    let ticking = false;
    let limit = 0;
    let visible = null;
    const measure = function () {
      limit = hero.offsetTop + hero.offsetHeight * 0.3;
    };
    // Na rolagem só compara números: a medida da seção fica guardada e a classe só muda quando precisa
    const update = function () {
      ticking = false;
      const on = window.scrollY > limit;
      if (on !== visible) {
        visible = on;
        bar.classList.toggle('is-visible', on);
      }
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      measure();
      update();
    });
    measure();
    update();
  }

  // 3. Feedbacks: cada cartão flutua num ritmo sorteado, e a animação pausa fora da tela
  const floats = document.querySelector('[data-vip-float]');
  if (floats) {
    const rand = function (min, max) {
      return min + Math.random() * (max - min);
    };
    Array.prototype.forEach.call(floats.querySelectorAll('.vip-fb__card'), function (card) {
      const duration = rand(4.5, 8.5);
      card.style.setProperty('--fa', rand(5, 11).toFixed(1) + 'px');
      card.style.setProperty('--fd', duration.toFixed(2) + 's');
      // Atraso negativo: cada cartão já começa num ponto diferente do vaivém
      card.style.setProperty('--fl', (-rand(0, duration * 2)).toFixed(2) + 's');
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        floats.classList.toggle('is-paused', !entries[0].isIntersecting);
      }).observe(floats);
    }
  }

  // 4. Contador regressivo até o fim das inscrições
  const count = document.querySelector('[data-vip-countdown]');
  if (count) {
    const fim = Date.parse(count.dataset.target);
    const nums = {};
    ['d', 'h', 'm', 's'].forEach(function (u) {
      nums[u] = count.querySelector('[data-unit="' + u + '"]');
    });
    const rotulos = { d: count.querySelector('[data-label="d"]'), h: count.querySelector('[data-label="h"]') };
    const sr = count.querySelector('[data-vip-countdown-sr]');
    let ultimoMinuto = -1;
    const dois = function (n) {
      return n < 10 ? '0' + n : String(n);
    };
    const poe = function (el, texto) {
      if (el && el.textContent !== texto) el.textContent = texto;
    };
    let relogio = null;
    const tick = function () {
      const resta = isNaN(fim) ? 0 : fim - Date.now();
      if (resta <= 0) {
        count.hidden = true;
        if (relogio) clearInterval(relogio);
        return;
      }
      const t = Math.floor(resta / 1000);
      const d = Math.floor(t / 86400);
      const h = Math.floor((t % 86400) / 3600);
      const m = Math.floor((t % 3600) / 60);
      poe(nums.d, dois(d));
      poe(nums.h, dois(h));
      poe(nums.m, dois(m));
      poe(nums.s, dois(t % 60));
      poe(rotulos.d, d === 1 ? 'dia' : 'dias');
      poe(rotulos.h, h === 1 ? 'hora' : 'horas');
      // Para leitor de tela: uma frase por minuto, sem anunciar cada segundo
      if (sr && m !== ultimoMinuto) {
        ultimoMinuto = m;
        sr.textContent = 'Faltam ' + d + (d === 1 ? ' dia, ' : ' dias, ') + h + (h === 1 ? ' hora e ' : ' horas e ') + m +
          (m === 1 ? ' minuto' : ' minutos') + ' para o fim das inscrições.';
      }
    };
    tick();
    relogio = setInterval(tick, 1000);
  }

  // 2. Rolagem suave, com aceleração e frenagem e duração proporcional à distância
  let running = null;
  const ease = function (t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };
  const jump = function (y) {
    try {
      window.scrollTo({ top: y, behavior: 'instant' });
    } catch {
      window.scrollTo(0, y);
    }
  };
  const stop = function () {
    if (running) cancelAnimationFrame(running);
    running = null;
  };
  // Se a pessoa rolar durante a animação, ela manda
  ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
    window.addEventListener(type, stop, { passive: true });
  });

  const scrollToY = function (y, done) {
    stop();
    const start = window.scrollY;
    const distance = y - start;
    if (reduceMotion.matches || Math.abs(distance) < 2) {
      jump(y);
      done();
      return;
    }
    const duration = Math.min(1400, Math.max(650, Math.abs(distance) * 0.35));
    let t0 = null;
    const step = function (now) {
      if (t0 === null) t0 = now;
      const p = Math.min(1, (now - t0) / duration);
      jump(start + distance * ease(p));
      if (p < 1) {
        running = requestAnimationFrame(step);
      } else {
        running = null;
        done();
      }
    };
    running = requestAnimationFrame(step);
  };

  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[data-vip-scroll]');
    if (!link) return;
    const hash = link.getAttribute('href');
    const target = hash && hash.charAt(0) === '#' && document.getElementById(hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const y = Math.max(0, target.getBoundingClientRect().top + window.scrollY);
    scrollToY(y, function () {
      // Leva o foco junto (teclado e leitor de tela), sem mexer na rolagem
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });
})();
